import { evalAuthHeaders, getEvalBase } from '../../evalApiBase'
import {
  buildRatingsListQuery,
  Rating,
  RatingFilters,
  RatingListResponse,
} from './ratingsModel'

export async function listRatings(filters: RatingFilters): Promise<RatingListResponse> {
  const query = buildRatingsListQuery(filters)
  const res = await fetch(`${getEvalBase()}/v1/response-ratings?${query}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Response ratings list failed: ${res.status}`)
  }
  return res.json()
}

export async function getRating(ratingId: string): Promise<Rating> {
  const res = await fetch(`${getEvalBase()}/v1/response-ratings/${ratingId}`, {
    headers: evalAuthHeaders(),
  })
  if (!res.ok) {
    throw new Error(`Response rating fetch failed: ${res.status}`)
  }
  return res.json()
}
